import { useMemo } from 'react';
import { useQuery } from '@ts-core/lib/apollo';

import { getErrorMessage } from '@ts-core/lib/apollo';
import { getVideosBySubjectQuery } from 'modules/media/graphql/queries';

export default function useVideos({ courseId, subjectId }) {
  /**
   * Get Videos
   */
  const { data, loading, error, refetch } = useQuery(getVideosBySubjectQuery, {
    variables: {
      courseId,
      subjectId,
    },
    skip: !courseId || !subjectId,
    fetchPolicy: 'cache-and-network',
  });
  const videos = useMemo(() => data?.videos || [], [data]);

  return {
    videos,
    loading,
    error: getErrorMessage({ error }),
    refetchVideos: refetch,
  };
}
